import { useEffect, useRef } from 'react';

type Timeout = {
  timeout: ReturnType<typeof setTimeout>;
  alwaysClean: boolean;
};

export const useTimeout = () => {
  const timeoutsRef = useRef<Timeout[]>([]);

  const addTimeout = (callback: () => void, timeout: number, alwaysClean = true) => {
    timeoutsRef.current.push({ timeout: setTimeout(callback, timeout), alwaysClean });
  };

  useEffect(
    () => () => {
      timeoutsRef?.current?.filter(({ alwaysClean }) => alwaysClean).forEach(({ timeout }) => clearTimeout(timeout));
    },
    []
  );

  return addTimeout;
};
